import { ResolveFn } from '@angular/router';
import { AppEvents } from '@commoncore/utils/app-events';

export const FileOperationsResolver: ResolveFn<boolean> = (route, state) => {
  if(route.data && route.data["jchome"]){
    AppEvents.createNewGlobalObservable();
    AppEvents.createNewSubscriptionsForLogin();
  }
  AppEvents.createNewFileOperationsSubscriptions();
  // $("#jc-app-init-loader-cont").hide();
  return true;
};
